
import Notification from '../components/common/Notification';
import { NotificationsActionTypeKeys } from './notificationsActionTypes';

export const addNotification = (notification: Notification) => {
  return {
    notification,
    type: NotificationsActionTypeKeys.ADD_NOTIFICATION
  } as IAddNotificationsAction;
}

export interface IAddNotificationsAction {
  readonly type: NotificationsActionTypeKeys.ADD_NOTIFICATION;
  readonly notification: Notification;
}

export const clearNotifications = () => {
  return {
    type: NotificationsActionTypeKeys.CLEAR_NOTIFICATIONS
  } as IClearNotificationsAction;
}

export interface IClearNotificationsAction {
  readonly type: NotificationsActionTypeKeys.CLEAR_NOTIFICATIONS;
}


// WEBPACK FOOTER //
// ./src/actions/notificationsActions.ts